module.exports = __webpack_public_path__ + "img/footer_icon_fb.0efd3de0.svg";